<template lang="pug">
div
  CommunityQPublishModal
  StoryEmailModal

  router-link.btn.btn-info.pull-right(:to="`/issues/${page.issue.id}`")
    i.fa.fa-arrow-left
    |
    | Back
  h1
    | {{ page.title }}
    |
    small {{ page.issue.title }}

  hr

  LoaderOverlay(:loading="loading")
    .row
      .col-md-9
        h2 Stories

        StoryFileDrop
          .alert.alert-info(v-if="stories.length === 0") No stories were found
          StoriesTable(v-else :columns="COLUMNS" @sort="sortStories" @should-refresh="fetchStories()")

          div.text-right
            a.btn.btn-default(
              v-if="storyBatchOptionsStore.anySelectedStories"
              :href="downloadStoriesLink"
            )
              i.fa.fa-cloud-download
              |
              | Download {{ storyBatchOptionsStore.selectedStoriesCount }} {{ storyBatchOptionsStore.selectedStoriesCount === 1 ? 'Story' : 'Stories' }}
            |
            |
            NewStoryButton

        hr

        .header
          h2 Files

          FileBreadcrumbs(:resource-slug="page.slug")

          .download-all.text-right
            a.btn.btn-default(@click="downloadZip")
              i.fa.fa-download
              |
              | Download All

        FileIndex(:resourceGlobalId="pageGlobalId")

      Sidebar.col-md-3.page
</template>

<script>
  import { ref, computed, onMounted } from 'vue'
  import store from '@/store'
  import { GlobalId } from '@/utils/global_id'
  import { trimEnd } from 'lodash'
  import { useFilesStore } from '@/stores/files'
  import { usePageStore } from '@/stores/page'
  import { useStoryBatchOptionsStore } from '@/stores/story_batch_options'

  import CommunityQPublishModal from '@/components/community_q/publish_modal.vue'
  import FileBreadcrumbs from '@/components/files/breadcrumbs.vue'
  import FileIndex from '@/components/files/index.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'
  import NewStoryButton from '@/components/stories/index/new_story_button.vue'
  import Sidebar from './sidebar.vue'
  import StoriesTable from '@/components/stories/index/stories_table.vue'
  import StoryEmailModal from '@/components/stories/email_modal.vue'
  import StoryFileDrop from '@/components/stories/index/story_file_drop.vue'

  const COLUMNS = [
    'color',
    'checkbox',
    'id',
    'byline',
    'slug',
    'sections',
    'words',
    'media',
    'exported',
    'squeue',
    'actions'
  ];

  export default {
    components: {
      CommunityQPublishModal,
      FileBreadcrumbs,
      FileIndex,
      LoaderOverlay,
      NewStoryButton,
      Sidebar,
      StoriesTable,
      StoryEmailModal,
      StoryFileDrop
    },

    props: {
      issueId: {
        required: true,
        type: Number
      },
      pageId: {
        required: true,
        type: Number
      }
    },

    setup(props) {
      const filesStore = useFilesStore()
      const pageStore = usePageStore()
      const storyBatchOptionsStore = useStoryBatchOptionsStore()

      const loading = ref(true)

      const page = computed(() => pageStore.page)
      const stories = computed({
        get: () => store.state.stories.stories,
        set: (val) => { store.state.stories.stories = val }
      })

      const pageGlobalId = computed(() => {
        return new GlobalId({ model: 'Page', id: props.pageId }).toString()
      })

      const downloadStoriesLink = computed(() => {
        return `/stories.zip?${jQuery.param({ ids: storyBatchOptionsStore.selectedStoryIds })}`
      })

      function fetchStories(queryAddons = {}) {
        return store.dispatch(
          'stories/fetch',
          {
            query: { pages_id_eq: props.pageId, ...queryAddons },
            // We don't want to really do pagination at this level
            page: 1, prePage: 1000
          }
        )
      }

      function sortStories({ column, direction }) {
        fetchStories({ s: `${column} ${direction}` })
      }

      function downloadZip() {
        const path = filesStore.resourceFilesPath

        window.location = `${trimEnd(path, '/')}.zip`
      }

      onMounted(async () => {
        await pageStore.fetch(props.pageId)
        await store.dispatch('squeues/fetchOnce')
        await fetchStories()

        loading.value = false
      })

      return {
        COLUMNS,
        loading,
        page,
        stories,
        pageGlobalId,
        storyBatchOptionsStore,
        downloadStoriesLink,
        fetchStories,
        sortStories,
        downloadZip
      }
    }
  }
</script>

<style scoped>
  .header {
    display: flex;
  }

  .header h2 {
    margin-right: 0.5em;
  }

  .header .download-all {
    flex-grow: 1;
  }
</style>
